export const theme = {
  colors: {
    primary: '#ffffff',
    secondary: '#00B4D8', // Light Blue
    tertiary: '#6C63FF', // Purple
    text: '#333333',
    textLight: '#666666',
    background: '#F4F7F6',
    white: '#ffffff',
    black: '#000000',
    success: '#2ecc71',
    danger: '#e74c3c',
    warning: '#f1c40f',
    info: '#3498db',
    border: '#e0e0e0',
  },
  fonts: {
    main: "'Poppins', sans-serif",
    heading: "'Montserrat', sans-serif",
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '992px',
    large: '1200px',
  },
  spacing: (factor) => `${factor * 0.5}rem`,
  shadows: {
    small: '0 2px 4px rgba(0,0,0,0.1)',
    medium: '0 4px 6px rgba(0,0,0,0.1)',
    large: '0 10px 15px rgba(0,0,0,0.1)',
  }
};
